var _g, _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2379_36031)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35.5,
    stroke: "#03B8FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39.9999,
    r: 29,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 10.9999C46.7389 10.9999 53.7116 13.8032 58.9978 18.8486C64.285 23.895 67.4874 30.8058 67.9436 38.1769C68.3999 45.5482 66.0749 52.8147 61.4495 58.4975C56.8249 64.1793 50.2504 67.8495 43.068 68.7717",
    stroke: "#03B8FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3059 48.3756C36.4826 48.3756 34.3592 47.2322 33.0526 45.6689L34.8259 43.7556C35.9226 45.0156 37.4626 45.7856 39.1892 45.7856C41.1259 45.7856 42.2926 44.8289 42.2926 43.4289C42.2926 42.0056 41.1259 41.2589 38.8392 41.2589L37.0426 41.2823V38.7623H38.8392C40.7292 38.7856 41.9659 38.0156 41.9659 36.6156C41.9659 35.3089 40.7292 34.3989 39.0026 34.3989C37.3926 34.3989 36.1792 35.1689 35.0826 36.3823L33.3559 34.6089C34.6392 32.9989 36.5059 31.7856 39.2359 31.7856C42.6659 31.7856 44.9292 33.6056 44.9292 36.1489C44.9292 38.0856 43.5992 39.3456 41.8959 39.8589C43.5992 40.2556 45.2792 41.4923 45.2792 43.6622C45.2792 46.4156 42.8992 48.3756 39.3059 48.3756Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2379_36031",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2379_36031"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeIcon);
export default __webpack_public_path__ + "static/media/three_icon.76440fdffa45ea7a5725a5e574785209.svg";
export { ForwardRef as ReactComponent };